<section class="h-full-header d-flex flex-column">
	<json-ld *ngIf="websiteSchema" [json]="websiteSchema"></json-ld>
	<json-ld *ngIf="organizationSchema" [json]="organizationSchema"></json-ld>
	<!-- <app-global-banner [inline]="true"></app-global-banner> -->
	<section class="my-auto d-flex flex-column align-items-center px-0">
		<div class="d-flex flex-column container-capped-sm px-0">
			<div class="p-3 text-center">
				<img src="/assets/images/KarpisheLogo.svg" class="w-100 h-100" alt="کارپیشه" title="کارپیشه">
			</div>
			<div class="d-flex justify-content-center">
				<h1 class="fs-normal fs-md-xxl">موتور جستجوی فرصت‌های شغلی ایران</h1>
			</div>
			<div class="col p-0 d-flex align-items-center">
				<div>
				</div>
			</div>
			<!-- <div class="col-5 pl-4 pl-md-0 pr-3 d-none d-md-block" >
					<img src="/assets/images/landing/home-1.svg" class="w-100" alt="اینجا برای همه کار هست"/>
				</div> -->
		</div>
		<div class="w-100 w-md-50">
			<div class="d-block mt-3 mt-md-5 pb-3 px-3">
				<app-search-box [(ngModel)]="params" [is-homepage]="true"></app-search-box>
			</div>
			<div class="col-12 py-md-3 fs-normal text-center" *ngIf="data?.jobs">
				{{data.jobs | number}} آگهی استخدام جدید در دو هفته اخیر
			</div>
		</div>
		<div class="mt-5 x-light-gray-bg text-center p-3 w-100">
			<div class="mb-3 fw-bold">
				خدمات بررسی اولیه و جذب نیرو جهت استخدام
			</div>
			<a class="btn btn-dark fs-lg px-4" routerLink="hire" >بخش کارفرمایان</a>
		</div>
	</section>
	<section class="text-center pb-3">
		<div class="btn btn-icon-circle border-gray" scroll-to=".fold-2">
			<i class="fa fa-angle-down f-gray"></i>
		</div>
	</section>

</section>
<div class="fold-2"></div>
<section class="container-fluid x-light-gray-bg py-3 " *ngIf="!(user|async)?.Seeker?.Code && !(user|async)?.Employer">
	<div class="d-lg-none text-center">
		<div class="py-2 px-1">
			<h3 class="h5">دنبال کار می‌گردی؟</h3>
			<h3>
				<a class="btn btn-white w-100" routerLink="/seeker" ga-event="request|post-resume">
					<i class="fa fa-user-plus fs-lg ml-2"></i>
					اینجا ثبت‌نام کن</a>
			</h3>
		</div>
		<div class="py-2 px-1">
			<h3 class="h5">می‌خوای کسی رو استخدام کنی؟</h3>
			<h3>
				<a class="btn btn-dark w-100" routerLink="/hire" ga-event="request|hire">
					<i class="fa fa-bullhorn fs-lg ml-2"></i>
					بخش کارفرمایان</a>
			</h3>
		</div>

	</div>
	<div class="container d-none d-lg-block">
		<div class="row text-center">
			<div class="col-6 pl-2 pl-lg-3">
				<div class="rounded-xl shadow-kp white-bg py-3 px-2 px-lg-4 w-100">
					<h3 class="fw-bold mb-2 h5">دنبال کار می‌گردی؟</h3>
					<div class="lh-sm px-3 no-wrap">به سادگی با جواب دادن به چند سوال صاحب رزومه شو. </div>
					<h3>
						<a class="btn btn-white mt-3 w-50" routerLink="/seeker" ga-event="request|post-resume">
							<i class="fa fa-user-plus fs-lg ml-2"></i>
							ثبت رزومه</a>
					</h3>
				</div>

			</div>
			<div class="col-6 pr-2 pr-lg-3">
				<div class="rounded-xl shadow-kp white-bg py-3 px-2 px-lg-4 w-100">
					<h3 class="fw-bold mb2 h5">قصد استخدام داری؟</h3>
					<div class="lh-sm px-3 no-wrap">
						از خدمات کارپیشه برای استخدام نیروی جدید استفاده کن
					</div>
					<h3>
						<a class="btn btn-dark mt-3 w-50" routerLink="/hire" ga-event="request|hire">
							<i class="fa fa-bullhorn fs-lg ml-2"></i>
							بخش کارفرمایان</a>
					</h3>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="container pt-3 white-bg">
	<div class="row">
		<div class="col-12 col-md-6 mb-3">
			<a class="d-block relative rounded-xl border border-dark-gray shadow-kp bg-cover" routerLink="/seeker/karpasha"
				style="height: 165px;background-position: left;"
				[style.background-image]="'url(/assets/images/seeker/vanguard/card-bg.svg)'">
				<div class="f-dark-gray h-100 d-flex flex-column p-2">
					<div class="p-1">
						<h2 class="fs-xxl fw-bold mb-0">از بقیه جلوتر باش</h2>
						<h3 class="fs-lg lh-sm fw-bold">
							کارجوی پیشتاز شو
						</h3>
					</div>
					<div class="d-flex flex-grow-1 align-items-end text-center">
						<div class="btn btn-vanguard">
							<img class="ml-2 icon-sm" src="/assets/images/icons/vanguard-seeker-white.svg" alt="کارجوی پیشتاز">
							<span>همین حالا کارجوی پیشتاز شو</span>
						</div>
					</div>
				</div>
			</a>
		</div>

<!-- change bg picture-->
		<div class="col-12 col-md-6 mb-3">
					<a class="d-block relative rounded-xl border border-dark-gray shadow-kp bg-cover" routerLink="/account/rtw/post"
					style="height: 165px;background-position: left;"
					[style.background-image]="'url(/assets/images/rtwd/rtw_bg.svg)'">
					<div class="f-dark-gray h-100 d-flex flex-column p-2">
						<div class="p-1">
							<h2 class="fs-xxl fw-bold mb-0">آماده‌ به کار </h2>
							<h3 class="fs-lg lh-sm fw-bold"> ویترین آنلاین معرفی کسب و کار
								<br />
							خدمات و محصولات شما
							</h3>
						</div>
						<div class="d-flex flex-grow-1 align-items-end text-center">
							<div class="btn btn-blue d-block d-md-inline-block">ثبت آگهی آماده‌به‌کار</div>
						</div>
		
					</div>
				</a>
			</div>

	</div>
</section>
<div class="container">
	<div class="row">
		<div class="col">
			<app-search-list></app-search-list>
		</div>
	</div>
</div>
<section class="container px-4 p-md-3 py-3 border-bottom border-dark-gray" *ngIf="data?.employers?.length">
	<h2 class="h4">استخدام در شرکت‌های معتبر</h2>
	<div class="row">
		<div class="col-12 col-md-3 p-3 d-md-flex" *ngFor="let user of data?.employers">
			<a class="d-block shadow-kp white-bg rounded-xl w-100 p-3 text-center"
				[routerLink]="['/company',user.Employer.Code]">
				<img class="contain mw-100 mb-2 mx-auto" [src]="companyLogo(user.Employer.Logo)" [alt]="user.Employer.Company"
					style="width: 150px; height: 100px;" onerror="this.src='/assets/images/clipart/avatar-company-1.svg'" />
				<h3 class="fs-lg">{{user.Employer.Company}}</h3>
				<div class="btn btn-yellow fs-sm py-1">{{user.Employer._jobCount | number}} فرصت‌ شغلی</div>
			</a>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-md-2 mr-auto fs-normal -left">
			<a routerLink="/company" class="rounded-xl border border-medium-gray my-1 px-2 d-block text-center ">
				نمایش همه...</a>
		</div>
	</div>
</section>
<div class="container text-center overflow-auto  mt-2" *ngIf="data?.topQueries?.length">
	<div class="row">
		<div class="col-12 col-md-9 mx-auto">
			<h2 class="my-3 h4">جستجوهای پربازدید</h2>
			<a *ngFor="let query of data?.topQueries" [routerLink]="['/job',{q:query}]" ga-event="top-query|{{query}}"
				class="rounded-xl border border-medium-gray mb-1 ml-1 px-1 d-inline-block shadow-kp-sm">
				{{query}}<i class="fa fa-search fs-sm pr-2 "></i></a>
		</div>
	</div>
</div>
<div class="container text-center overflow-auto  my-3" *ngIf="data?.topQueries?.length">
	<div class="row">
		<div class="col-12 col-md-9 mx-auto">
			<h2 class="my-3 h4">شهرهای پربازدید</h2>
			<a *ngFor="let city of data?.cities" [routerLink]="['/job',{l:[city.State, city.City].join('،')}]"
				class="rounded-xl border border-medium-gray mb-1 ml-1 px-1 d-inline-block shadow-kp-sm"
				title="{{city._Count | number}} آگهی استخدام در شهر {{city.City}}">
				استخدام در {{city.City}}<i class="fa fa-search fs-sm pr-2 "></i></a>
		</div>
	</div>
</div>